import styled from 'styled-components';

export const PendDocsHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const PendDocsTitle = styled.div`
  font-size: 14px;
  text-align: center;
  color: #161d1f;

  b {
    font-size: 20px;
    color: #161d1f;
    line-height: 32px;
    font-weight: 900;
  }

  p {
    font-size: 20px;
  }

  span {
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #161d1f;
    margin-top: 8px;
    font-weight: 500;
  }
`;

export const PendDocsBody = styled.div`
  text-align: start;
  font-size: 14px;
  color: #161d1f;
  display: grid;
  grid-template-columns: 20px 1fr;
  /* align-items: center; */
  justify-content: center;
  gap: 3px;
  margin-top: 10px;
  width: 275px;

  img {
    // padding: 2px auto;
    width: 16px;
    height: 16px;
    display: inline-block;
    // margin-right: 50px;
  }

  @media (max-width: 640px) {
    font-size: 14px;
    width: 248px;
  }
`;
